import { LogoMark } from '@apovisio/ui';

export function BrandMark({ subtitle }: { subtitle?: string }) {
  return (
    <span className="app-brand">
      <LogoMark />
      <span>
        Apogée Visio
        {subtitle ? <span className="av-text-secondary av-text-sm"> · {subtitle}</span> : null}
      </span>
    </span>
  );
}
